var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddFilled = function SvgAddFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.196 3.819c-3.411-3.42-8.966-3.42-12.377 0-3.42 3.411-3.42 8.966 0 12.377a8.727 8.727 0 0 0 6.188 2.56c2.236 0 4.487-.85 6.189-2.56 3.41-3.411 3.41-8.974 0-12.386v.009Zm-2.069 6.814h-3.503v3.503a.63.63 0 0 1-.625.625.63.63 0 0 1-.626-.625v-3.503H5.871a.63.63 0 0 1-.626-.626.63.63 0 0 1 .625-.625h3.503V5.879A.63.63 0 0 1 10 5.253a.63.63 0 0 1 .625.626v3.503h3.503a.63.63 0 0 1 .626.625.63.63 0 0 1-.626.626Z",
    fill: "current"
  })));
};
export default SvgAddFilled;